import { useState, useCallback } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useVolunteerAttendance() {
  const { api, AdminId } = useGlobalContext();

  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);

  const shouldShowLocalError = (data) => {
    return (
      data?.responseCode !== "00" &&
      data?.responseCode !== "02" &&
      data?.responseCode !== "03" &&
      data?.responseCode !== "98" &&
      data?.responseCode !== "401"
    );
  };

  const normalizeAttendanceStatus = (status) => {
  const value = String(status || "").toLowerCase().trim();

  if (value === "f") return "full_day";
  if (value === "h") return "half_day";
  if (value === "a") return "absent";
  if (value === "p") return "pending";
  if (value === "pn") return "pending";

  if (value.includes("full")) return "full_day";
  if (value.includes("half")) return "half_day";
  if (value.includes("absent")) return "absent";
  if (value.includes("pending")) return "pending";

  return "pending";
};

  const getVolunteerUserId = () => {
    try {
      const volunteerData = JSON.parse(
        sessionStorage.getItem("volunteerData") || "{}"
      );

      return String(
        volunteerData?.userId ||
          volunteerData?.userid ||
          volunteerData?.id ||
          AdminId ||
          ""
      );
    } catch (error) {
      return String(AdminId || "");
    }
  };

  /* ---------------- FETCH VOLUNTEER ATTENDANCE ---------------- */

  const fetchVolunteerAttendance = useCallback(
    async ({ volunteerCode = "", fromDate = "", toDate = "" } = {}) => {
      setLoading(true);

      try {
        const body = {
          adminId: getVolunteerUserId(),
          volunteerCode: String(volunteerCode || ""),
          fromDate: String(fromDate || ""),
          toDate: String(toDate || ""),
        };

        const res = await api.post(
          "/api/VolunteerAdmin/v2.0/getVolunteerAttendanceRecord",
          body
        );

        if (res?.data?.responseCode === "00") {
          const raw = Array.isArray(res?.data?.data) ? res.data.data : [];

          const formatted = raw.map((v) => {
            const attendanceMap = {};

            (v.attendance || []).forEach((a) => {
              if (!a?.date) return;

              attendanceMap[a.date] = {
  status: normalizeAttendanceStatus(a.status),
  totalDutyHours: a.totalDutyHours || "0h 0m",
  timings: Array.isArray(a.timings) ? a.timings : [],
};
            });

            return {
              ...v,
              volunteerCode: v.volunteerCode || v.volunteer_code,
              name: v.name,
              type: v.type || "normal",
              attendanceMap,
            };
          });

          setAttendanceData(formatted);

          return formatted;
        }

        if (shouldShowLocalError(res?.data)) {
          toast.error(
            res?.data?.responseMessage || "Failed to fetch attendance record"
          );
        }

        setAttendanceData([]);
        return [];
      } catch (error) {
        console.error("fetchVolunteerAttendance error:", error);
        toast.error("Error fetching attendance record");
        setAttendanceData([]);
        return [];
      } finally {
        setLoading(false);
      }
    },
    [api, AdminId]
  );

  /* ---------------- UPDATE VOLUNTEER ATTENDANCE ---------------- */

  const updateVolunteerAttendance = useCallback(
  async (dataArray = []) => {
    if (!dataArray.length) {
      toast.message("No changes to update");
      return false;
    }

    setLoading(true);

    try {
      const body = {
        adminId: getVolunteerUserId(),
        data: dataArray.map((item) => ({
          volunteerCode: String(item.volunteerCode || ""),
          date: String(item.date || ""),
          status: String(item.status || ""),
        })),
      };

      console.log("UPDATE VOLUNTEER ATTENDANCE PAYLOAD:", body);

      const res = await api.post(
        "/api/VolunteerAdmin/v1.0/updateVolunteerAttendanceRecord",
        body
      );

      console.log("UPDATE VOLUNTEER ATTENDANCE RESPONSE:", res?.data);

      if (res?.data?.responseCode === "00") {
        toast.success(
          res?.data?.responseMessage || "Attendance Updated Successfully"
        );

        return true;
      }

      toast.error(res?.data?.responseMessage || "Attendance update failed");
      return false;
    } catch (error) {
      console.error("updateVolunteerAttendance error:", error);
      toast.error("Error updating attendance");
      return false;
    } finally {
      setLoading(false);
    }
  },
  [api, AdminId]
);

  return {
    attendanceData,
    setAttendanceData,
    loading,
    fetchVolunteerAttendance,
    updateVolunteerAttendance,
    getVolunteerUserId,
  };
}